<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle" :type="'home'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="hr">
          <!-- 약관 (s) -->
          <div class="termsWrap mt0">
            <div class="inner">
              <ul class="iptGroup">
                <li>
                  <div class="block">
                    웰몰 서비스 이용약관 필수 동의
                    <button type="button" class="links arrow" @click="openPop('webViewPop', 1)"><span class="blind">상세약관 전체보기</span></button>
                  </div>
                </li>
                <li>
                  <div class="block">
                    개인정보수집 및 이용약관 필수 동의
                    <button type="button" class="links arrow" @click="openPop('webViewPop', 2)"><span class="blind">상세약관 전체보기</span></button>
                  </div>
                </li>
                <li>
                  <div class="block">
                    개인정보수집 및 이용약관 선택 동의
                    <button type="button" class="links arrow" @click="openPop('webViewPop', 3)"><span class="blind">상세약관 전체보기</span></button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- 약관 (e) -->
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <MessagePop v-if="messagePop" @close="messagePopClose">
      <p v-html="msg"></p>
    </MessagePop>
    <WebViewPop v-if="webViewPop" :pageName="pageName" @close="close">
      <div v-html="webView"></div>
      <div class="singleIpt" v-if="agreeSelectType">
        <input type="checkbox" class="ipt notDel uiAct" name="terms1" id="terms1_1" v-model="termCheck" />
        <label for="terms1_1">
          {{ agreeUsingService ? '동의를 철회합니다.' : '동의합니다.' }}
          <span class="pointC8" v-show="agreeUsingService">
            (동의일자 :
            <i>{{ agreeDate }}</i>
            )
          </span>
        </label>
      </div>
      <template v-slot:bottomButton v-if="agreeSelectType">
        <button type="button" class="btn_p" @click="putAgreeSelect" :disabled="!termCheck">
          확인
        </button>
      </template>
      <template v-slot:bottomButtonArea v-else>
        <div></div>
      </template>
    </WebViewPop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import WebViewPop from '@/components/popup/WebViewPop';
import JwtService from '@/common/jwt.service';
import MessagePop from '@/components/popup/MessagePop';
import $ from 'jquery';
export default {
  name: 'serviceUseAgree',
  components: {
    WebViewPop,
    MessagePop,
  },
  async mounted() {
    this.userInfoInit();

    let webViews = await ApiService.service('GET', 'common/webView/WB000003');
    this.webViews = webViews.data.result;
    if (JwtService.getUserInfo()) this.userId = JwtService.getUserInfo().userId;
  },
  data: function() {
    return {
      headerTitle: '서비스 이용 동의',
      webViewUrl: null,
      pageName: null,
      webViews: [],
      webView: null,
      webViewPop: false,
      termCheck: false,
      termYn: false,
      agreeUsingService: false,
      agreeDate: '',
      agreeSelectType: false,
      userId: '',
      msg: '',
      messagePop: false,
    };
  },
  methods: {
    userInfoInit: function() {
      ApiService.service('GET', 'user/auth')
        .then(({ data }) => {
          console.log(data);
          this.agreeUsingService = data.result.agreeUsingService;
          this.agreeDate = data.result.agreeDate;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    openPop: function(name, num, pageName) {
      this.pageName = pageName;
      this.termCheck = false;
      //console.log(this.webViews);
      if (name == 'webViewPop') {
        this.webViewUrl = this.webViews[num - 1].filePath;
        this.pageName = this.webViews[num - 1].pageName;
      }
      if (num == 3) {
        this.agreeSelectType = true;
      } else {
        this.agreeSelectType = false;
      }
      this.webViewPop = true;
      ApiService.service('GET', this.webViewUrl)
        .then(({ data }) => {
          console.log(data);
          this.webView = data;
          this.webViewPop = true;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    close() {
      this.confirmPop = false;
      this.bottomPop = false;
      this.noticePop = false;
      this.webViewPop = false;
      this.sharePop = false;
      this.findAddr = false;
    },
    messagePopClose() {
      this.messagePop = false;
      this.$router.push('/changeUserInfo');
    },
    putAgreeSelect() {
      ApiService.service('PUT', '/user/auth/serviceagree', {
        request: {
          agree: this.agreeUsingService ? 'N' : 'Y',
          userId: this.userId,
        },
        serviceType: 'app',
      })
        .then(({ data }) => {
          if (data.isSucceed) {
            this.webViewPop = false;
            this.msg =
              ' 개인정보수집 및 이용약관 선택 동의를<br>' +
              (this.agreeUsingService ? '철회하셨습니다.' : '동의하셨습니다.') +
              this.$moment(new Date()).format('(YYYY.MM.DD)');
            this.messagePop = true;

            this.userInfoInit();
            //this.$router.push('/changeUserInfo');
          } else {
            this.msg = data.error;
            this.messagePop = true;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
          this.categoryList = [];
        });
    },
  },
};
</script>
